/** Remembered authoring readiness is separate from the active pointer mode. */
export type PaintingFamily = 'draw' | 'stamp' | 'image';
export type PaintingDrawerIntent = 'collapse' | 'required-source' | 'open-options' | 'toggle-options';
export interface PaintingModeState {
  handActive: boolean;
  family?: PaintingFamily;
  readyStamp: boolean;
  readyImage: boolean;
}
export type PaintingModeAction = {type:'toggle-hand'} | {type:'select-family';family:PaintingFamily;revealDrawTools?:boolean} | {type:'select-target'} | {type:'paint-committed'};
export interface PaintingModeDecision {handActive:boolean;family:PaintingFamily;drawer:PaintingDrawerIntent}

export function activePaintingFamily(handActive:boolean,rememberedFamily:PaintingFamily='draw'):PaintingFamily|null {
  return handActive ? null : rememberedFamily;
}

/** Describes existing setter/disclosure actions; owns no settings, sources or target state. */
export function decidePaintingMode(state:Readonly<PaintingModeState>,action:Readonly<PaintingModeAction>):PaintingModeDecision {
  const remembered=state.family??'draw';
  const family=action.type==='select-family'?action.family:remembered;
  const handActive=action.type==='paint-committed'||(action.type==='toggle-hand'&&!state.handActive);
  const ready=family==='draw'||(family==='stamp'?state.readyStamp:state.readyImage);
  const drawer:PaintingDrawerIntent=handActive?'collapse':
    action.type==='select-family'&&!state.handActive&&family===remembered?'toggle-options':
    action.type==='select-family'&&family==='draw'&&action.revealDrawTools?'open-options':
    ready?'collapse':'required-source';
  return {handActive,family,drawer};
}

export interface PaintingNavigationGuards {
  busy?:boolean;
  uncertain?:boolean;
  preparing?:boolean;
  modalOpen?:boolean;
  cropOpen?:boolean;
}
/** Ordinary options/preparation expansion is deliberately not a navigation guard. */
export function paintingNavigationPresentation(guards:Readonly<PaintingNavigationGuards>={}):{visible:boolean;disabled:boolean} {
  const foreground=!!(guards.modalOpen||guards.cropOpen);
  return {visible:!foreground,disabled:foreground||!!(guards.busy||guards.uncertain||guards.preparing)};
}
